export const NAV = {
  root: 'top-nav',
  ctaWaitlist: 'top-nav-join-waitlist-button',
  brand: 'top-nav-brand',
};

export const HERO = {
  root: 'hero',
  badge: 'hero-launching-soon-badge',
  headline: 'hero-headline',
  sub: 'hero-subheadline',
  ctaWaitlist: 'hero-join-waitlist-button',
  ctaHowItWorks: 'hero-how-it-works-button',
};

export const STATS = { root: 'mission-stats' };
export const PROBLEM = { root: 'problem-section' };
export const SOLUTION = { root: 'solution-section', flowPrefix: 'solution-flow' };
export const HOW = { root: 'how-it-works', stepPrefix: 'how-step' };
export const POP = {
  root: 'point-of-purchase',
  scanCta: 'pop-scan-cta',
  surfacesPrefix: 'pop-surface',
};
export const TRUST = { root: 'trust-strip' };
export const BENEFITS = { root: 'benefits' };

export const WAITLIST = {
  section: 'waitlist-section',
  form: 'waitlist-form',
  brandName: 'waitlist-brand-name-input',
  contactName: 'waitlist-contact-name-input',
  email: 'waitlist-email-input',
  website: 'waitlist-website-input',
  brandSize: 'waitlist-brand-size-select',
  industry: 'waitlist-industry-select',
  certifications: 'waitlist-certifications-picker',
  certsTrigger: 'waitlist-certifications-trigger',
  certOptionPrefix: 'waitlist-certification-option',
  notes: 'waitlist-notes-textarea',
  submit: 'waitlist-submit-button',
  success: 'waitlist-success-state',
  error: 'waitlist-form-error',
  honeypot: 'waitlist-honeypot-input',
};

export const FOOTER = {
  root: 'site-footer',
  privacy: 'footer-privacy-link',
  contact: 'footer-contact-link',
  impressum: 'footer-impressum-link',
  terms: 'footer-terms-link',
};

export const PRIVACY = {
  root: 'privacy-page',
  title: 'privacy-page-title',
  backHome: 'privacy-back-home',
  sectionPrefix: 'privacy-section',
};

export const CONTACT = {
  root: 'contact-page',
  title: 'contact-page-title',
  emailBtn: 'contact-email-button',
  privacyEmailBtn: 'contact-privacy-email-button',
  addressCard: 'contact-address-card',
  backHome: 'contact-back-home',
};

export const ADMIN = {
  // testId for the password INPUT element (this is NOT a stored credential)
  loginPasswordInput: 'admin-login-password-input',
  loginSubmit: 'admin-login-submit-button',
  loginError: 'admin-login-error',
  shell: 'admin-shell',
  search: 'admin-signups-search-input',
  export: 'admin-signups-export-csv-button',
  refresh: 'admin-signups-refresh-button',
  logout: 'admin-logout-button',
  table: 'admin-signups-table',
  rowPrefix: 'admin-signups-row',
  empty: 'admin-signups-empty-state',
  pagination: 'admin-signups-pagination',
  prev: 'admin-signups-prev-page',
  next: 'admin-signups-next-page',
  rowDetail: 'admin-signups-row-detail',
};
